const DEFAULT_PLAN_DEADLINE = '09:30'
const DEFAULT_SUMMARY_DEADLINE = '18:30'
const DEFAULT_TEAM_PLAN_REMINDER_OFFSET = -30
const DEFAULT_TEAM_SUMMARY_REMINDER_OFFSET = -20

export function normalizeLeaderDepartmentRules(data) {
  if (Array.isArray(data)) return data
  if (Array.isArray(data?.records)) return data.records
  if (Array.isArray(data?.list)) return data.list
  if (Array.isArray(data?.items)) return data.items
  if (Array.isArray(data?.departments)) return data.departments
  if (Array.isArray(data?.leaderDepartments)) return data.leaderDepartments
  return []
}

export function normalizeDepartmentRules(data) {
  if (Array.isArray(data)) return data
  if (Array.isArray(data?.records)) return data.records
  if (Array.isArray(data?.list)) return data.list
  if (Array.isArray(data?.items)) return data.items
  if (Array.isArray(data?.rules)) return data.rules
  if (data?.rule) return [data.rule]
  return []
}

export function createDepartmentRuleForm(department = {}) {
  const rule = department.rule || {}
  const currentVersion = positiveInteger(rule.versionNo, 0)
  const departmentScoped = isDepartmentRuleSource(department, rule)

  return {
    departmentId: department.departmentId ?? department.deptId ?? rule.scopeTargetId ?? '',
    departmentName: department.departmentName || department.deptName || rule.scopeTargetName || '--',
    versionNo: departmentScoped ? currentVersion + 1 : 1,
    effectiveFrom: localDate(),
    effectiveTo: '',
    planDeadline: timeInputValue(rule.planDeadline || DEFAULT_PLAN_DEADLINE),
    summaryDeadline: timeInputValue(rule.summaryDeadline || DEFAULT_SUMMARY_DEADLINE),
    dailyReportEnabled: rule.dailyReportEnabled !== false,
    teamPlanReminderEnabled: rule.teamPlanReminderEnabled === true,
    teamPlanReminderOffsetMinutes: integerOrDefault(
      rule.teamPlanReminderOffsetMinutes,
      DEFAULT_TEAM_PLAN_REMINDER_OFFSET
    ),
    teamSummaryReminderEnabled: rule.teamSummaryReminderEnabled === true,
    teamSummaryReminderOffsetMinutes: integerOrDefault(
      rule.teamSummaryReminderOffsetMinutes,
      DEFAULT_TEAM_SUMMARY_REMINDER_OFFSET
    )
  }
}

export function buildDepartmentRulePayload(form) {
  return {
    departmentId: Number(form.departmentId),
    versionNo: Number(form.versionNo),
    effectiveFrom: form.effectiveFrom,
    effectiveTo: form.effectiveTo || null,
    planDeadline: form.planDeadline || null,
    summaryDeadline: form.summaryDeadline || null,
    dailyReportEnabled: form.dailyReportEnabled !== false,
    teamPlanReminderEnabled: form.teamPlanReminderEnabled === true,
    teamPlanReminderOffsetMinutes: form.teamPlanReminderEnabled === true
      ? integerOrDefault(form.teamPlanReminderOffsetMinutes, DEFAULT_TEAM_PLAN_REMINDER_OFFSET)
      : null,
    teamSummaryReminderEnabled: form.teamSummaryReminderEnabled === true,
    teamSummaryReminderOffsetMinutes: form.teamSummaryReminderEnabled === true
      ? integerOrDefault(form.teamSummaryReminderOffsetMinutes, DEFAULT_TEAM_SUMMARY_REMINDER_OFFSET)
      : null
  }
}

export function formatDateRange(rule) {
  const from = rule?.effectiveFrom || '--'
  const to = rule?.effectiveTo || '长期有效'
  return `${from} 至 ${to}`
}

export function formatRuleTime(value) {
  return timeInputValue(value) || '--'
}

export function formatReminderOffset(enabled, offset) {
  if (!enabled) return '未开启'
  const value = Number(offset)
  if (!Number.isFinite(value)) return '已开启'
  if (value === 0) return '截止时'
  return value < 0 ? `截止前 ${Math.abs(value)} 分钟` : `截止后 ${value} 分钟`
}

export function ruleSourceLabel(row) {
  if (row?.inherited === true || row?.rule?.inherited === true) return '继承系统默认'
  const sourceScope = String(row?.sourceScope || row?.rule?.sourceScope || row?.rule?.scope || '').toUpperCase()
  if (sourceScope && sourceScope !== 'DEPARTMENT') return '继承系统默认'
  return '部门规则'
}

export function isInheritedRule(row) {
  return ruleSourceLabel(row) === '继承系统默认'
}

function isDepartmentRuleSource(department, rule) {
  if (department.inherited === true || rule.inherited === true) return false
  const sourceScope = String(department.sourceScope || rule.sourceScope || rule.scope || '').toUpperCase()
  return sourceScope === 'DEPARTMENT'
}

function positiveInteger(value, fallback) {
  const number = Number(value)
  if (!Number.isInteger(number) || number <= 0) return fallback
  return number
}

function integerOrDefault(value, fallback) {
  if (value === null || value === undefined || value === '') return fallback
  const number = Number(value)
  return Number.isInteger(number) ? number : fallback
}

function timeInputValue(value) {
  if (!value) return ''
  return String(value).slice(0, 5)
}

function localDate() {
  const now = new Date()
  const offset = now.getTimezoneOffset()
  return new Date(now.getTime() - offset * 60 * 1000).toISOString().slice(0, 10)
}
